// Helpers: date formatting, follow-up classification, status helpers.

export function pad2(n) {
  return String(n).padStart(2, "0");
}

// ISO → DD-MM-YYYY
export function toDDMMYYYY(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

export function toDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()} ${pad2(
    d.getHours()
  )}:${pad2(d.getMinutes())}`;
}

export function daysFromToday(iso) {
  if (!iso) return null;
  const target = new Date(iso);
  const today = new Date();
  target.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

export function followUpBucket(iso) {
  const d = daysFromToday(iso);
  if (d === null) return null;
  if (d < 0) return { key: "overdue", label: `OVERDUE · ${Math.abs(d)}d`, cls: "fu-overdue" };
  if (d === 0) return { key: "today", label: "TODAY", cls: "fu-today" };
  if (d === 1) return { key: "tomorrow", label: "TOMORROW", cls: "fu-tomorrow" };
  return { key: "in_nd", label: `IN ${d}d`, cls: "fu-in_nd" };
}

export const STATUSES = ["NEW", "CONTACTED", "IN_PROGRESS", "WON", "LOST"];

export const LOSS_REASONS = [
  { value: "PRICE", label: "Price" },
  { value: "DELIVERY_TIME", label: "Delivery Time" },
  { value: "CHOSE_COMPETITOR", label: "Chose Competitor" },
  { value: "PRODUCT_RANGE_NA", label: "Product range not available" },
  { value: "OTHERS", label: "Others" },
];
export const lossReasonLabel = (v) => LOSS_REASONS.find((r) => r.value === v)?.label || v || "—";

// Quick-pick caption tags for site-inspection photos. FEs can also type a custom caption.
export const PHOTO_TAGS = [
  "Elevation",
  "Kitchen",
  "Balcony",
  "Bedroom",
  "Bathroom",
  "Living Room",
  "Exterior",
  "Terrace",
  "Windows",
  "Site Front",
];

export function statusClass(status) {
  return `sohom-chip status-${(status || "NEW").toUpperCase()}`;
}

export function leadNextDate(lead) {
  // Compute the next upcoming visit from OPEN (non-completed) follow-ups only.
  // The lead-level `next_visit_date` is used only as a fallback when there are no
  // follow-ups at all (e.g. legacy leads / mobile-created leads without follow_ups).
  const fus = lead.follow_ups || [];
  if (fus.length > 0) {
    const openDates = fus
      .filter((f) => !f.completed && f.next_visit_date)
      .map((f) => f.next_visit_date)
      .sort();
    return openDates[0] || null;
  }
  return lead.next_visit_date || null;
}
